import { useState } from 'react';
import cn from 'classnames';

import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';
import { Body, useIntersectionObserver } from '@rikstv/shared-components';

import { ReactComponent as StarEmpty } from './gfx/star_empty.svg';
import { ReactComponent as StarFilled } from './gfx/star_filled.svg';

import style from './Quote.module.css';

export const Quote: FCC<{ author: string; idx?: number; stars?: number }> = ({
  children,
  author,
  idx = 0,
  stars = 0,
}) => {
  const [isInViewport, setIsInViewport] = useState(false);

  const onIntersect = (entires: IntersectionObserverEntry[]) => {
    if (isInViewport) {
      return;
    }
    setIsInViewport(entires.some(entry => entry.isIntersecting));
  };
  const fallback = () => setIsInViewport(true);

  const [targetRef] = useIntersectionObserver(onIntersect, {}, fallback);

  const getRating = (stars?: number) => {
    switch (stars) {
      case 0:
        return 0;
      case 1:
        return (
          <>
            <StarFilled aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
          </>
        );
      case 2:
        return (
          <>
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
          </>
        );
      case 3:
        return (
          <>
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
          </>
        );
      case 4:
        return (
          <>
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarEmpty aria-hidden="true" />
          </>
        );
      case 5:
        return (
          <>
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
            <StarFilled aria-hidden="true" />
          </>
        );
      default:
        return 'ingen stjerner';
    }
  };

  return (
    <div
      style={{ transitionDelay: `${idx * 50}ms` }}
      ref={targetRef}
      className={cn(style.quote, { [style.animateIn]: isInViewport })}>
      <div className={style.bubble}>
        <div className={style.stars}>{getRating(stars)}</div>
        <Body>«{children}»</Body>
      </div>
      <div className={style.signature}>
        <Body>{author}</Body>
      </div>
    </div>
  );
};
